export const images = {
  image1x: require(`demo-event-loader/loader@1x.png`),
  image2x: require(`demo-event-loader/loader@2x.png`),
  image3x: require(`demo-event-loader/loader@3x.png`),
};
